import { ArrowRight } from 'lucide-react'
import { copy } from '../../copy/investor-copy'
import { useSearchSuggestionsQuery } from '../../hooks/use-investor-assistant'
import type { SearchCriteriaShape } from './criteria-chips'

interface Suggestion {
  label: string
  count: number
  criteria: SearchCriteriaShape
  fromProfile: boolean
}

/** Under the box before any answer: starting points from the firm's investor profile, each with its live count. */
export function PhraseSuggestions({
  onRun,
  onEditFocus,
}: {
  onRun: (item: Suggestion) => void
  /** Opens the watchdog, where the saved focus is set. */
  onEditFocus: () => void
}) {
  const suggestions = useSearchSuggestionsQuery()
  const items = suggestions.data?.data.items ?? []
  if (items.length === 0) return null
  return (
    <section aria-labelledby="phrase-suggestions-heading">
      <div className="flex items-baseline justify-between gap-3">
        <h3
          id="phrase-suggestions-heading"
          className="text-xs font-medium uppercase tracking-wider text-muted-foreground"
        >
          {copy('search.suggest.heading')}
        </h3>
        {items.some((item) => item.fromProfile) ? (
          <button
            type="button"
            onClick={onEditFocus}
            className="inline-flex items-center gap-1 text-xs text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline"
          >
            {copy('search.suggest.focus')}
            <ArrowRight className="size-3" aria-hidden />
          </button>
        ) : (
          <span className="text-xs text-muted-foreground">{copy('search.suggest.starters')}</span>
        )}
      </div>
      <ul className="mt-2.5 flex flex-wrap gap-1.5">
        {items.map((item) => (
          <li key={item.label}>
            <button
              type="button"
              onClick={() => onRun(item)}
              className="rounded-full border border-border px-3 py-1.5 text-[12.5px] text-foreground transition-colors hover:border-foreground/40"
            >
              {item.label}
              <span className="ml-1.5 tabular-nums text-muted-foreground">
                {copy('search.suggest.count', { n: item.count })}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  )
}
